import { find } from "lodash/fp";
import { shallow } from "zustand/shallow";

import type { SelectChangeEvent } from "@mui/material";

import useCalendarStore from "@app/analytics/Calendar/hooks/useCalendarStore";
import type { ConferencingFilter } from "@app/analytics/Calendar/types";

import Dropdown from "@rui/Dropdown";
import DropdownMenuItem from "@rui/Dropdown/DropdownMenuItem";

const CONFERENCING_FILTERS: { label: string; value: ConferencingFilter }[] = [
  {
    label: "Show all events",
    value: "all",
  },
  {
    label: "Has video conferencing",
    value: "conferencing_only",
  },
  {
    label: "No video conferencing",
    value: "no_conferencing_only",
  },
];

const VideoConferencingDropdown = () => {
  const [conferencing, setConferencing] = useCalendarStore(
    (state) => [state.conferencing, state.setConferencing],
    shallow
  );

  const selectedItem = find(
    (f) => f.value === conferencing,
    CONFERENCING_FILTERS
  );

  const handleChange = (event: SelectChangeEvent) =>
    setConferencing(event.target.value as ConferencingFilter);

  return (
    <Dropdown
      name="conferencing"
      selectedItem={selectedItem}
      onChange={handleChange}
      sx={{
        minWidth: "210px",
        height: "40px",
        "& .MuiSelect-select": { fontWeight: 500 },
        "& fieldset": {
          borderColor: "shades.neutral.100",
        },
      }}
    >
      {CONFERENCING_FILTERS.map((item) => (
        <DropdownMenuItem
          key={item.value}
          label={item.label}
          selected={conferencing === item.value}
          value={item.value}
        />
      ))}
    </Dropdown>
  );
};

export default VideoConferencingDropdown;
